import AboutUs from '@/views/about-us.vue'
import PrivacyPolicy from '@/views/privacy-policy.vue'
import TermsConditions from '@/views/terms-conditions.vue'
import ChangePassword from '@/views/admin/change-password.vue'
import ResetPassword from '@/views/admin/reset-password.vue'
import CreateAccount from '@/views/admin/create-account.vue'
import DashboardPage from '@/views/admin/dashboard-page.vue'
import BlogDetail from '@/views/blog/blog-detail.vue'
import BlogPage from '@/views/blog/blog-page.vue'
import ContactPage from '@/views/contact-page.vue'
import FaqPage from '@/views/faq-page.vue'
import IndexSeven from '@/views/index/index-seven.vue'
import { createRouter, createWebHistory } from 'vue-router'
import ExhibitDetail from '@/views/property/ExhibitDetail.vue';
import HallDetail from '@/views/property/HallDetail.vue';
import standDetail from '@/views/property/standDetail.vue';
import ExhibitsGrid from '@/views/property/Exhibits-grid.vue';
import PrevExhibitsGrid from '@/views/property/prevExhibits-grid.vue';
import citiesGrid from '@/views/property/cities-grid.vue';
import ExhibitsSearch from '@/views/property/Exhibits-search.vue';
import NotFound from '@/views/NotFound.vue';
import countriesGrid from '@/views/property/countries-grid.vue';
import VerifyEmail from '@/views/admin/VerifyEmail.vue';
import ExhibitsCategories from '@/views/admin/ExhibitsCategories.vue';
import SoonExhibits from '@/views/admin/SoonExhibits.vue';
import DeleteAccount from '@/views/property/DeleteAccount.vue';
import ServiceDetail from '@/views/property/ServiceDetail.vue';
import CompleteProfile from '@/views/admin/CompleteProfile.vue'
import RegisterVisit from '@/views/admin/RegisterVisit.vue';
import AttendeePage from '@/views/AttendeePage.vue';
import AttendeeForm from '@/views/AttendeeForm.vue';
import CompaniesPage from '@/views/CompaniesPage.vue';
import CompanyDetail from '@/views/property/CompanyDetail.vue';
import ExhibitForm from '@/views/property/ExhibitForm.vue';
import EmployeeForm from '@/views/property/EmployeeForm.vue';

const routes = [
  {
  path: '/:lang',
  children: [
  { path: '', component: IndexSeven},
  { path: 'about-us', component: AboutUs},
  { path: 'privacy-policy', component: PrivacyPolicy},
  { path: 'terms-conditions', component: TermsConditions},
  { path: 'blog', component: BlogPage},
  // { path: 'blog-detail', component: BlogDetail},
  { path: 'blog-detail/:slug',name:'BlogDetail', component: BlogDetail},
  { path: 'faq', component: FaqPage},
  { path: 'contact', component: ContactPage},
  { path: 'dashboard/:id', component: DashboardPage},
  { path: 'create-account', component: CreateAccount},
  { path: 'change-password', component: ChangePassword},
  { path: 'reset-password', component: ResetPassword},
  { path: 'complete-profile', component: CompleteProfile},
  { path: 'register-visit', component: RegisterVisit},
  { path: 'exhibit/:slug', name: 'ExhibitDetail',component: ExhibitDetail, props: true },
  { path: 'exhibit/drafts/:slug', component: ExhibitDetail, props: true },
  { path: 'hall/:slug', name: 'HallDetail',component: HallDetail, props: true },
  { path: 'hall/drafts/:slug', component: HallDetail, props: true },
  { path: 'stand/:slug', component: standDetail, props: true },
  { path: 'stand/drafts/:slug', component: standDetail, props: true },
  { path: 'exhibits', component: ExhibitsGrid, props: true },
  { path: 'cities', component: citiesGrid, props: true },
  { path: 'exhibits/search',name:'ExhibitSearch', component: ExhibitsSearch, props: true },
  { path: 'countries', component: countriesGrid, props: true },
  { path: 'prev-exhibits', component: PrevExhibitsGrid, props: true },
  { path: 'verify-email',component: VerifyEmail, props: true },
  { path: 'exhibits-categories',component: ExhibitsCategories, props: true },
  { path: 'soon-exhibits',component: SoonExhibits, props: true },
  { path: 'delete-account',component: DeleteAccount, props: true },
  { path: 'service/:serviceSlug', component: ServiceDetail, props: true },
  { path: 'attendees/:code', component: AttendeePage, props: true },
  { path: 'attendees', component: AttendeeForm, props: true },
  { path: 'companies', component: CompaniesPage, props: true },
  { path: 'company/:slug', name: 'CompanyDetail',component: CompanyDetail, props: true },
  { path: 'attendee/exhibit/:code', name: 'ExhibitForm',component: ExhibitForm, props: true },
  { path: 'employees/:code', name: 'EmployeeForm',component: EmployeeForm, props: true },
 ]
  },

  { path: '/', redirect:'/en' },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {
      top: 0,
      behavior: "smooth", 
    };
  }
})
import i18n from '@/i18n'

router.beforeEach((to, from, next) => {
  const lang = to.params.lang

  if (lang && ['en', 'ar'].includes(lang)) {
    i18n.global.locale.value = lang
    localStorage.setItem('locale', lang)

    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }

  next()
})
export default router
